
<template>
  <div>
    <div class="notification is-padding is-warning columns is-gapless is-vcentered is-margin-bottom-small">
      <div class="column has-text-primary has-text-weight-bold is-uppercase is-size-7">
        LA PROCÉDURE DE PASSAGE EN RÉSERVATION VOUS PERMET DE BLOQUER LE LOT JUSQU’A LA SIGNATURE DU CONTRAT DE RÉSERVATION. <br>
        POUR VALIDER VOTRE DEMANDE DE PASSAGE EN RÉSERVATION DU LOT, MERCI DE RENSEIGNER LES INFORTMATIONS ATTENDUES SUR ACQUÉREUR(S) MAIS AUSSI SUR LES OPTIONS PROPOSÉES (<span class="icon is-small"><i class="fas fa-check-circle"></i></span>). <br>
        SI LE PROMOTEUR A SOUHAITÉ CONTROLER VOTRE DEMANDE, VOUS SEREZ NOTIFIÉ PAR MAIL DÈS SA PRISE EN CHARGE ET RECEVREZ UNE NOTIFICATION DE VALIDATION OU DE REFUS.
      </div>
    </div>
    <div class="has-background-light">
      <div class="is-padding is-border">
        <div class="columns">
          <div class="column is-4">
            <div class="is-margin-bottom-xsmall">
              <r-label
                class="has-text-black has-text-weight-light"
                :label="'Sélectionner Destination'"
                :red-check="true"
                :value="reservation.destination">
              </r-label>
            </div>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  class=""
                  @change="$store.commit('modifyCurrentReservation', { key: 'destination', value: reservation.destination })"
                  v-model="reservation.destination">
                  <option :value="null">
                    Sélectionner
                  </option>
                  <option
                    v-for="a in advDestinationsList"
                    :key="a.value"
                    :value="a.value">
                    {{ a.label }}
                  </option>
                </select>
              </div>
            </div>
            <p
              v-if="error.destination"
              class="help is-danger">
              Le champ est obligatoire
            </p>
          </div>
          <div
            v-if="reservation.destination === 'invest' || reservation.destination === 'main_residence'"
            class="column is-4">
            <div class="is-margin-bottom-xsmall">
              <r-label
                v-if="reservation.destination === 'invest'"
                :label="'Sélectionner Dispositif'"
                :red-check="true"
                :value="reservation.tax_dispositif"></r-label>
              <r-label
                v-else-if="reservation.destination === 'main_residence'"
                :is-required="false"
                :label="'Sélectionner Dispositif'"
                :no-check="true"
                :value="reservation.tax_dispositif"></r-label>
            </div>
            <div v-if="reservation.destination === 'invest' || reservation.destination === 'main_residence'">
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    v-model="reservation.tax_dispositif"
                    @change="$store.commit('modifyCurrentReservation', { key: 'tax_dispositif', value: reservation.tax_dispositif })"
                    :class="{'is-border' : reservation.destination !== 'invest' || !availableDispositifs}">
                    <option
                      :value="null"
                      selected>
                      Sélectionner
                    </option>
                    <template>
                      <option
                        v-for="a in dispositifs"
                        :key="a.value"
                        :value="a.value">
                        {{ a.label }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
              <p
                v-if="error.tax"
                class="help is-danger">
                Le champ est obligatoire
              </p>
            </div>
          </div>
          <div
            v-if="!isSeller"
            class="column is-4">
            <div class="is-margin-bottom-xsmall">
              <r-label
                class="has-text-black has-text-weight-light"
                :label="'Mandat de gestion'"
                :is-required="true"
                :green-check="true"
                :value="reservation.mandat_de_gestion"></r-label>
            </div>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  class=""
                  @change="$store.commit('modifyCurrentReservation', { key: 'mandat_de_gestion', value: reservation.mandat_de_gestion })"
                  v-model="reservation.mandat_de_gestion"
                  id="mandat_de_gestion">
                  <option :value="null">
                    NC
                  </option>
                  <option :value="true">
                    Oui
                  </option>
                  <option :value="false">
                    Non
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="background-color: #eff3f6">
        <div
          style="margin-bottom: 0"
          class="columns is-gapless is-mobile has-background-white is-minH50p is-border-left is-border-right is-border-bottom">
          <div class="column is-padding-left is-padding-right is-self-centered">
            <span
              style="font-weight: 400"
              class="is-uppercase title is-6">Réservataire(s) / Acquéreur(s)</span>
          </div>
          <div
            id="dropdownMenuActions"
            class="dropdown is-hoverable is-right is-border-left">
            <div class="dropdown-trigger is-flex">
              <button
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                style="padding-left: 5rem; padding-right: 5rem"
                class="page-header-btn page-header-btn--separetedIco-right is-widthFixToHeaderAccount is-small is-secondary">
                <span>Ajouter Co-Acquéreur</span>
              </button>
            </div>
            <div
              id="dropdown-menu"
              role="menu"
              class="dropdown-menu">
              <div class="dropdown-content is-paddingless">
                <a
                  v-if="canAdd"
                  @click="openBuyerSelection"
                  class="dropdown-item">
                  <span class="icon is-medium">
                    <i class="fas fa-users"></i>
                  </span>
                  <span class="is-margin-left-xsmall">Sélectionner un co-acquéreur</span>
                </a>
                <a
                  v-if="canAdd"
                  @click="openNewContactQuickview({}, null, null, null, true)"
                  class="dropdown-item">
                  <span class="icon is-medium">
                    <i class="fas fa-users-medical"></i>
                  </span>
                  <span class="is-margin-left-xsmall">Créer un co-acquéreur</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <template>
          <div
            v-for="(buyer, index) in buyers"
            :key="buyer.pk">
            <membre-pre-resa
              class="has-background-white is-margin-bottom-xxsmall"
              :class="index > 0 ? 'is-border' :'is-border-bottom is-border-left is-border-right'"
              :for-pre-resa="true"
              :is-grey="true"
              :membre="buyer"
              @updateContact="openModalContactPreResaInfo"
              @deleteCobuyer="deleteBuyer"
              @deleteDocument="deleteDocument"
              :is-co-acquereur="index > 0"
              :is-membre-promoteur="false"
              :modal-promoteur="false"
              :can-edit="(currentUser.account.pk === buyer.account.pk || currentUser.pk === buyer.user.pk) && (isEditing || isRefused)">
            </membre-pre-resa>
          </div>
        </template>
        <div class="columns is-gapless is-border-bottom is-border-left is-border-right is-margin-bottom">
          <div
            class="column is-narrow is-flex is-padding-small"
            :class="validNotary ? 'has-background-success' : 'has-background-white--darken1 tooltip is-tooltip-right'"
            :data-tooltip="'Notaire client incomplet'">
            <span
              class="icon has-text-white is-self-centered"
              :class="validNotary ? 'has-text-white' : 'has-text-danger'"><i
                :class="validNotary ? 'fa-check-circle' : 'fa-exclamation-circle'"
                class="fas"></i></span>
          </div>
          <div class="column has-background-white">
            <div class="is-padding">
              <span class="is-uppercase is-6">Notaire client</span>
            </div>
            <div
              class="is-padding-left-small is-padding-right-small is-flex is-minH50p is-border-top"
              :class="!reservation.notary_details.use_buyer_notary ? 'has-background-white' : ' has-background-dark'">
              <div class="is-self-centered is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
                <div>
                  <input
                    id="use_buyer_notary"
                    v-model="reservation.notary_details.use_buyer_notary"
                    name="use_buyer_notary"
                    class="switch is-success is-rounded"
                    type="checkbox">
                  <label
                    for="use_buyer_notary"
                    :class="!reservation.notary_details.use_buyer_notary ? '' : 'has-text-white'"
                    class="is-uppercase">Renseigner le notaire de l'acquéreur</label>
                </div>
              </div>
            </div>
            <div
              v-if="!isPending && reservation.notary_details.use_buyer_notary"
              class="is-border-top is-padding">
              <div class="columns is-multiline">
                <div class="column is-6">
                  <r-label
                    :label="reservation.notary_details.tiers_id ? 'Notaire du référentiel' : 'Rechercher un notaire au référentiel'"
                    :is-required="false"
                    :value="reservation.notary_details.tiers_id" />
                  <tiers-selector
                    :selected="selectedNotaireClient"
                    :slot-ref="reservation.notary_details"
                    :types="['notaire']"
                    placeholder="Nom, ville..."
                    @select="selectNotaireClient"
                    @unlink="unlinkNotaireClient" />
                </div>
                <div class="column is-6"></div>
                <div class="column is-6">
                  <r-label
                    label="Nom du notaire"
                    :is-required="true"
                    :red-check="true"
                    :value="reservation.notary_details.name"></r-label>
                  <div class="control">
                    <v-input
                      id="reservation.notary_details.name"
                      :disabled="!!reservation.notary_details.tiers_id"
                      name="reservation.notary_details.name"
                      :model="reservation.notary_details.name"
                      v-validate="'min:2'"
                      @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.name', value: val })"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      classes="input"
                      data-vv-as="Nom du notaire">
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Téléphone du notaire"
                    :is-required="true"
                    :red-check="true"
                    :value="reservation.notary_details.phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                  <div class="control">
                    <v-input
                      id="reservation.notary_details.phone"
                      :disabled="!!reservation.notary_details.tiers_id"
                      name="reservation.notary_details.phone"
                      :model="reservation.notary_details.phone"
                      v-validate="'min:10'"
                      @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.phone', value: val })"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-6">
                  <r-label
                    label="Email"
                    :value="reservation.notary_details.email"
                    :is-required="true"
                    :red-check="true"></r-label>
                  <div class="control">
                    <v-input
                      :has-addons="true"
                      id="reservation.notary_details.email"
                      :disabled="!!reservation.notary_details.tiers_id"
                      name="reservation.notary_details.email"
                      :model="reservation.notary_details.email"
                      v-validate="'email'"
                      :errors-bag="errors"
                      @input="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.email', value: val })"
                      data-vv-value-path="val"
                      data-vv-as="Email">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-static is-square is-static">
                          <span class="icon"><i class="fas fa-paper-plane"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                </div>
                <div class="column is-12">
                  <address-input
                    v-if="!reservation.notary_details.tiers_id"
                    label="Adresse de correspondance"
                    @update="val => $store.commit('modifyCurrentReservation', { key: 'notary_details.address', value: val })"
                    :source="reservation.notary_details.address"
                    :is-required="true"
                    :red-check="true">
                  </address-input>
                  <div
                    v-else
                    class="columns is-multiline">
                    <div class="column is-6">
                      <r-label
                        label="Adresse de correspondance"
                        :is-required="false"
                        :value="tiersAddressResume(reservation.notary_details.address)" />
                      <input
                        :value="tiersAddressResume(reservation.notary_details.address)"
                        type="text"
                        class="input"
                        disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Quickview } from '@/mixins'
import TiersLink from '@/components/tiers/TiersLinkMixin'

export default {
  name: 'DonneePreResa',
  components: {
    MembrePreResa: () => import('../MembrePreResa'),
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  mixins: [Quickview, TiersLink],
  props: {
    reservation: {
      type: Object,
      required: true
    },
    advDestinationsList: {
      type: Array,
      required: true
    },
    error: {
      type: Object,
      required: true
    },
    dispositifs: {
      required: true
    },
    buyers: {
      type: Array,
      required: true
    },
    openBuyerSelection: {
      type: Function,
      required: true
    },
    availableDispositifs: {
      required: true
    },
    openModalContactPreResaInfo: {
      required: true
    },
    deleteDocument: {
      required: true
    }
  },
  data () {
    return {
      selectedNotaireClient: null
    }
  },
  computed: {
    ...mapGetters(['isSeller']),
    ...mapState(['currentUser']),
    isPending () {
      return this.reservation.status === 'pending'
    },
    canAdd () {
      return this.buyers.length <= 2
    },
    validNotary () {
      if (this.reservation.notary_details.use_buyer_notary) {
        return this.reservation.notary_details.name !== null && this.reservation.notary_details.name !== '' && this.reservation.notary_details.phone !== null && this.reservation.notary_details.phone !== '' && this.reservation.notary_details.email !== null && this.reservation.notary_details.email !== '' && this.reservation.notary_details.address !== null && this.reservation.notary_details.address !== ''
      } else {
        return true
      }
    },
    isRefused () {
      return this.reservation.status === 'refused'
    },
    isEditing () {
      return this.reservation.status === 'editing'
    }
  },
  watch: {
    'reservation.notary_details.use_buyer_notary' (to) {
      // if (this.fromStart) return
      this.$store.commit('modifyCurrentReservation', { key: 'notary_details.use_buyer_notary', value: to })
    }
  },
  methods: {
    /**
     * Sélection d'un notaire du référentiel : lie et remplit les champs
     * @param {object} interlocuteur - { ...interlocuteur, tiers }
     */
    selectNotaireClient (interlocuteur) {
      this.selectedNotaireClient = interlocuteur
      this.applyTiersSelection(this.writeNotaireClient, interlocuteur)
    },
    /**
     * Délier du référentiel : vide aussi les champs (anti-doublon)
     */
    unlinkNotaireClient () {
      this.selectedNotaireClient = null
      this.applyTiersUnlink(this.writeNotaireClient)
    },
    /**
     * writer(key, value) du bloc notaire client — $set d'abord pour rendre
     * réactives les clés absentes du JSON (tiers_id, interlocuteur_id)
     */
    writeNotaireClient (key, value) {
      this.$set(this.reservation.notary_details, key, value)
      this.$store.commit('modifyCurrentReservation', { key: `notary_details.${key}`, value })
    },
    confirmDeleteBuyer () {
      return this.$swal({
        title: 'Suppression co-acquéreur',
        text: 'Souhaitez-vous vraiment retirer ce co-acquéreur ?',
        confirmButtonText: 'Supprimer',
        focusConfirm: false
      })
    },
    async deleteBuyer (buyer) {
      let value = await this.confirmDeleteBuyer()
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        let index = this.buyers.findIndex(x => x.pk === buyer.pk)
        if (index >= 0) {
          this.buyers.splice(index, 1)
          this.$store.commit('modifyCurrentReservation', { key: 'buyers', value: this.buyers })
          this.$toasted.global.success('L\'acquéreur a été supprimé.')
        }
      }
    }
  }
}
</script>
